import FormLabel from "@material-ui/core/FormLabel";
import React from "react";
import AvatarEditor from "react-avatar-editor";
import { connect } from "react-redux";

import { clearModal } from "../../../../actions/shared/uiActions.js";
import ActionModalContainer from "../../../General/ActionModal/ActionModalContainer";
import ActionModalContent from "../../../General/ActionModal/ActionModalContent";
import ActionModalFooter from "../../../General/ActionModal/ActionModalFooter";
import ActionModalHeader from "../../../General/ActionModal/ActionModalHeader";
import FileInput from "../FileInput.react";

class AvatarEditorModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      image: "", xPosition: 0.5, yPosition: 0.5, zoom: 1
    };
  }

  setEditorRef = (editor) => (this.editor = editor);

  handleChange = (_, newFile) => {
    this.setState({
      image: newFile,
    });
  };

  handleSave = () => {
    const canvas = this.editor.getImageScaledToCanvas();
    const context = canvas.getContext("2d");

    context.globalCompositeOperation = "destination-over";
    context.fillStyle = "#FFFFFF";
    context.fillRect(0, 0, canvas.width, canvas.height);

    const avatarSubmission = {};
    avatarSubmission.file = canvas.toDataURL();
    avatarSubmission.name = this.state.image.name;
    avatarSubmission.type = this.state.image.type;

    canvas.toBlob((blob) => {
      avatarSubmission.blob = blob;
      this.props.handleSave(avatarSubmission);
      this.props.clearModal();
    });
  };

  handleSlideChange = (e) => {
    this.setState({
      [e.target.id]: parseFloat(e.target.value),
    });
  };

  handlePositionChange = (coord) => {
    this.setState({
      xPosition: coord.x,
      yPosition: coord.y,
    });
  };

  renderSlider(label, controlName, min, max, step) {
    return (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span>{label}</span>
        <input
          id={controlName}
          type="range"
          min={min}
          max={max}
          step={step}
          onChange={(e) => this.handleSlideChange(e)}
          value={this.state[controlName]}
        />
      </div>
    );
  }

  renderEditorControls() {
    return (
      <div style={{ paddingTop: 20 }}>
        {this.renderSlider("Zoom", "zoom", 0, 2, 0.01)}
        {this.renderSlider("X Position", "xPosition", 0, 1, 0.01)}
        {this.renderSlider("Y Position", "yPosition", 0, 1, 0.01)}
      </div>
    );
  }

  renderFileUploadPrompt() {
    const { minSize, maxSize } = this.props;

    return (
      <>
        <div style={{ paddingBottom: 20 }}>
          Please select a new image to upload
        </div>

        <FileInput
          accept="image/jpeg, image/png"
          id="avatar"
          label="Select File"
          onChange={this.handleChange}
          value={this.state.image}
          overrideStyle={{ width: 300 }}
          minSize={minSize}
          maxSize={maxSize}
        />
      </>
    );
  }

  renderImageEditControls() {
    const {
      xPosition, yPosition, zoom, image
    } = this.state;
    const {
      width, height, borderRadius, controlHelperText
    } = this.props;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div>
            <FormLabel className="static-input-label">Controls</FormLabel>
            {this.renderEditorControls()}
            <p className="small">{controlHelperText}</p>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <FormLabel className="static-input-label">Preview</FormLabel>
          <AvatarEditor
            style={{ paddingTop: 20 }}
            ref={this.setEditorRef}
            width={width}
            height={height}
            borderRadius={borderRadius}
            image={image}
            scale={zoom}
            position={{
              x: xPosition,
              y: yPosition,
            }}
            onPositionChange={(coord) => this.handlePositionChange(coord)}
          />
        </div>
      </div>
    );
  }

  renderContent() {
    return (
      <div
        style={{
          width: "100%",
          height: 300,
          border: "1px dashed #008DAE",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        {!this.state.image
          ? this.renderFileUploadPrompt()
          : this.renderImageEditControls()}
      </div>
    );
  }

  render() {
    const { modalTitleText } = this.props;
    const { submitting } = this.state;

    return (
      <ActionModalContainer color="blue">
        <ActionModalHeader title={modalTitleText} subtitle="File Editor" />
        <ActionModalContent>{this.renderContent()}</ActionModalContent>
        <ActionModalFooter
          actionText="Save"
          handleAction={
            this.state.image
              ? this.handleSave
              : () => {
                this.setState({ submitting: false });
              }
          }
          isSubmitting={submitting}
        />
      </ActionModalContainer>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  clearModal: () => dispatch(clearModal()),
});

export default connect(null, mapDispatchToProps)(AvatarEditorModal);
